var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.id)?_c('h4',[_vm._v("Hér koma allar myndir ferilbókar")]):_vm._e(),_vm._l((_vm.categoryList),function(category){return _c('div',{key:category.id},[(category.hasPhotos !== 0)?_c('div',[_c('category-photos',{attrs:{"categoryId":category.id,"categoryName":category.name,"id":_vm.id,"student":_vm.student}})],1):_vm._e()])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }